<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between">
  <h5 class="mb-0">Arquivos para análise</h5>
  <ol class="breadcrumb mb-0 ps-0">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item">
      <a routerLink="/professionals">Profissionais</a>
    </li>
    <li class="breadcrumb-item fw-semibold">Arquivos</li>
  </ol>
</div>

<mat-card class="mb-25 tagus-card">
  <mat-card-content>
    <div class="toolbar" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
      <div class="left" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
        <mat-form-field appearance="fill" class="status-field">
          <mat-label>Status</mat-label>
          <mat-select [(value)]="status" (selectionChange)="onStatusChange()">
            <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="filter-field">
          <mat-icon matPrefix>search</mat-icon>
          <mat-label>Buscar</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Nome do arquivo, profissional, e-mail..." />
        </mat-form-field>
      </div>

      <div class="right" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button mat-stroked-button class="tagus" (click)="refresh()">
          <mat-icon>refresh</mat-icon>
          Atualizar
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card class="tagus-card">
  <mat-card-content>
    <div class="loading" *ngIf="loading">
      <mat-spinner diameter="42"></mat-spinner>
      <span>Carregando...</span>
    </div>

    <div class="mat-elevation-z8 tagus-mat-table" *ngIf="!loading">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="professional">
          <th mat-header-cell *matHeaderCellDef>Profissional</th>
          <td mat-cell *matCellDef="let file">
            <div class="professional-cell">
              <div class="name" (click)="openProfessional(file.professional?._id)">
                {{ file.professional?.fullname || '—' }}
              </div>
              <div class="sub">{{ file.professional?.email || '—' }}</div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Arquivo</th>
          <td mat-cell *matCellDef="let file">
            <div class="file-cell">
              <div class="file-name" [matTooltip]="file.name">{{ file.name }}</div>
              <div class="sub">{{ file.mimetype }} • {{ file.size | number }} bytes</div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let file">
            <mat-chip class="status" [ngClass]="file.status" disableRipple>
              {{ statusLabel(file.status) }}
            </mat-chip>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Criado</th>
          <td mat-cell *matCellDef="let file">{{ file.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td mat-cell *matCellDef="let file" class="actions">
            <button mat-icon-button matTooltip="Visualizar" (click)="viewFile(file)">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Baixar" (click)="downloadFile(file)">
              <mat-icon>download</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Abrir cadastro" (click)="openProfessional(file.professional?._id)">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <ng-container *ngIf="isAdmin()">
              <button mat-icon-button matTooltip="Aprovar" (click)="approve(file)">
                <mat-icon>check_circle</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Rejeitar" (click)="reject(file)">
                <mat-icon>cancel</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div class="empty" *ngIf="dataSource.data.length === 0">
        <mat-icon>inbox</mat-icon>
        <span>Nenhum arquivo encontrado.</span>
      </div>
    </div>

    <mat-paginator
      [length]="total"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 20, 50]"
      (page)="onPage($event)"
    ></mat-paginator>
  </mat-card-content>
</mat-card>

